import React, { Fragment } from "react";
import Logo from "../../components/Logo";
import "./styles.css";

const Figure = (props) => {
  const {
    className,
    title,
    subTitle,
    alertText,
    logo = false,
    imgSrc = null,
    customMessage,
    icon,
    subTitleClass
  } = props;

  return (
    <Fragment>
      {customMessage && (
        <div className={`${className}__message`}>{customMessage}</div>
      )}
      {logo && (
        <div className={`${className}__logo logo`}>
          <Logo />
        </div>
      )}
      {imgSrc && (
        <div className={`${className}-image`}>
          <img src={imgSrc} alt={`${className}-img`} />
        </div>
      )}
      {title && (
        <div className={`${className}__title font-30-bold-700 primary-color`}>
          {title}
        </div>
      )}
      {subTitle && (
        <div
          className={`${className}__subtitle sub-title font-16-normal-400 secondary-color ${subTitleClass}`}
        >
          {subTitle}
        </div>
      )}

      {alertText && (
        <div
          className={`${className}__alert figure-alert-text font-16-normal-400 primary-color`}
        >
          {icon && (
            <span>
              <img src={icon} alt={icon} />
            </span>
          )}
          <span>{alertText}</span>
        </div>
      )}
    </Fragment>
  );
};

export default Figure;
